import React from "react";
import ajax from "./../../lib/ajax.js";
import immutable from "immutable";
import moment from "moment";
import context from "./../../lib/context.js";
import { Checkbox, Modal } from "react-bootstrap";
import { browserHistory } from "react-router";
import { Alert } from "react-bootstrap";
import LoadingPanel from "./../shared/loading-panel.jsx";
import TCSummaryForm from "./tc-summary-form.jsx";

const FORM_STATE = {
    initial: 0,
    showAttestation: 1,
    showNoAnswer: 2
};

export default class TCSubmitForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            timecardId: null,
            timecardType: null,
            timecardStatus: "saved",
            clientName: "",
            employeeName: "",
            summary: null,
            disabled: true,
            agreementChecked: false,
            errorMessage: null,

            showAttestation: FORM_STATE.initial,
            attestationHeader: "",
            attestationHtml: "",
            attestationNoAnswer: "",
        };

        this.submitTimecard = this.submitTimecard.bind(this);
        this._getAttestationAnswer = this._getAttestationAnswer.bind(this);
        this._onAttestationSubmit = this._onAttestationSubmit.bind(this);
        this._initializeNoAnswerRadio = this._initializeNoAnswerRadio.bind(this);
    }

    componentDidMount() {
        console.log("MOUNTED");
        const self = this;
        this._survey = null;
        this.__surveyInit__ = false;
        ajax.vm()
            .get(`people/tc-submit/${self.props.params.timecardId}/${self.props.params.token}`)
            .then(function (res) {
                res.data.disabled = false;
                self.setState(immutable.fromJS(self.state).mergeDeep(res.data).toJS());
            }).then(() => {
                Promise.all([
                    ajax.public().get("res/TimecardSubmit.aspx/AttestationHeader"),
                    ajax.public().get("res/TimecardSubmit.aspx/AttestationNoAnswerText"),
                    ajax.public().get("res/TimecardSubmit.aspx/AttestationText"),
                    ajax.api().post("assert", {
                        claimType: "http://action.ain1.com/claims/people/attestation-disqualifier"
                    })
                ]).then(result => {
                    this.setState({
                        showAttestation: (result[3].data.hasClaim && !this.state.answeredAttestation ? FORM_STATE.showAttestation : FORM_STATE.initial),
                        attestationHeader: result[0].data,
                        attestationHtml: result[2].data,
                        attestationNoAnswer: result[1].data,
                    });
                });
            }).catch(function (err) {
                console.log(err);
                const res = err.response;
                context.message({
                    show: true,
                    type: "error",
                    message: res.data.exceptionMessage || res.data.message,
                    buttons: "close"
                }, function (b) {
                    context.redirectToHome();
                });
            });
    }

    componentDidUpdate() {
        console.log(this.props);
        const self = this;
        const timecardStatus = self.state.timecardStatus.toLowerCase();
        
        if (timecardStatus === "submitted" && !!self.state.showAttestation && !self.__surveyInit__) {
            const el = self.refs.attestDiv;

            /** @type {HTMLDivElement} */
            const progressEl = self.refs.attestProgressDiv;
            /** @type {HTMLSpanElement} */
            const loadingSpan = self.refs.attestLoadingSpan;


            self._survey = new SurveyApplication.Survey(el,
                context.url("app/api/get-attestation-survey"),
                {
                    onLoaded: (el, survey, args) => {
                        try {
                            const page = survey.getCurrentPage();
                            if (!page) {
                                this.setState({
                                    showAttestation: FORM_STATE.initial
                                });
                            }
                        } catch (err) {
                            if (!page) {
                                this.setState({
                                    showAttestation: FORM_STATE.initial
                                });
                            }
                        }
                    },
                    onUpdated: (el, survey, args) => {
                        loadingSpan.style.display = "none" // hide loading span
                        const page = survey.getCurrentPage();

                        if (page != null) {
                            if (page.name !== "Page1") {
                                self._initializeNoAnswerRadio();
                            }
                            const currentMilestone = page.milestone;
                            if (!isNaN(currentMilestone)) {
                                const percentage = Math.round(20 * currentMilestone); // 5 steps => 100/5
                                progressEl.style.width = `${percentage}%`;
                            }
                        }
                    },
                    onAnswered: (el, survey, args) => {
                        self._onAttestationSubmit();
                    },                    
                });

            self.__surveyInit__ = true;
        }
    }

    submitTimecard() {
        const self = this;
        if (!self.state.agreementChecked) {
            context.message({
                show: true,
                type: "error",
                message: "Please read and acknowledge to the agreement before submitting.",
                buttons: "close"
            });
            return false;
        }

        self.setState(
            immutable.fromJS(self.state)
                .mergeDeep({ disabled: true })
                .toJS()
        );
        if (self.state.timecardStatus.toLowerCase() !== "saved") {
            context.message({
                show: true,
                type: "error",
                message: "This timecard cannot be submitted!",
                buttons: "close"
            }, function () {
                context.redirectToHome();
            });
        } else {
            context.message({
                show: true,
                type: "loading",
                message: "Processing. Please wait..."
            });
            ajax.api()
                .post("submit-tc", {
                    timecardId: self.props.params.timecardId,
                    token: self.props.params.token
                })
                .then(function (res) {
                    const clone = immutable.fromJS(self.state);
                    clone.timecardStatus = "submitted";
                    self.setState(clone, () => context.message({ show: false }));                   
                    
                    browserHistory.push(context.routeUrl(`people/tc-submit-complete/${self.props.params.timecardId}/${self.props.params.token}`));
                })
                .catch(function (err) {
                    console.log(err);
                    const res = err.response;
                    const clone = immutable.fromJS(self.state);
                    clone.errorMessage = res.data.exceptionMessage || res.data.message
                    clone.disabled = false;
                    self.setState(clone, () => context.message({ show: false }));
                });
        }
    }

    _initializeNoAnswerRadio() {
        const attestDiv = this.refs.attestDiv;

        if (attestDiv != null) {
            const noRadios = attestDiv.getElementsByClassName("no-radio");
            console.log(noRadios);
            for (const noRadio of noRadios) {
                if (noRadio.__hasNoListener !== true) {
                    noRadio.addEventListener("change", (evt) => {
                        if (evt.target.checked) {
                            this.setState({
                                showAttestation: FORM_STATE.showNoAnswer
                            });
                        }
                    });
                    noRadio.__hasNoListener = true;
                }
            }
        }
    }

    _getAttestationAnswer() {
        const attestDiv = this.refs.attestDiv;

        if (attestDiv != null) {
            /** @type {HTMLInputElement} */
            const yesRadio = attestDiv.getElementsByClassName("yes-radio")[0];

            /** @type {HTMLInputElement} */
            const noRadio = attestDiv.getElementsByClassName("no-radio")[0];

            if (yesRadio != null && noRadio != null) {
                return yesRadio.checked ? "yes" :
                    noRadio.checked ? "no" : null;
            } else return null;
        } else return null;
    }

    _onAttestationSubmit() {
        const answer = this._getAttestationAnswer();

        const updateAttestationCallback = () => {
            const answerState = this._survey.getAnswerState();
            this._survey = null;
            this.__surveyInit__ = false;
            ajax.api().put(`update-timecard-attestation/${this.state.timecardId}/${this.props.params.token}`, answerState);
        }

        this.setState({
            showAttestation: FORM_STATE.initial
        }, updateAttestationCallback());

    }

    render() {
        const timecardStatus = this.state.timecardStatus.toLowerCase();
        if (timecardStatus == "submitted") {
            return this.renderSubmitted();
        } else {
            return this.renderSubmitting();
        }
    }

    renderSubmitted() {
        const self = this;
        return (
            <div className="ap-form-container ap-submit-body">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 col-md-7 col-md-offset-2">
                            <h2 className="text-center ap-submit-title">Submittal Confirmation</h2>
                        </div>
                        <div className="col-sm-12 col-md-7 col-md-offset-2 ap-top-margined">
                            Your timecard has been successfully submitted. <strong>
                                If you would like a copy of this confirmation for your record, please <a href="javascript:window.print();void(0);">print</a> this page.
                            </strong>
                        </div>
                        <div className="col-sm-12 col-md-7 col-md-offset-2 ap-top-margined">
                            {self.state.summary ?
                                <div className="container-fluid ap-border-color-lightgray" >
                                    <div className="row ap-submit-summary" style={{ lineHeight: "3rem" }}>
                                        <div className="col-sm-6 col-xs-6 col-md-3 col-lg-3">
                                            <strong>Timecard ID:</strong>
                                        </div>
                                        <div className="col-sm-6 col-xs-6 col-md-3 col-lg-3">
                                            {self.state.timecardId}
                                        </div>
                                        <div className="col-sm-6 col-xs-6 col-md-3 col-lg-3">
                                            <strong>Client Name:</strong>
                                        </div>
                                        <div className="col-sm-6 col-xs-6 col-md-3 col-lg-3">
                                            {self.state.clientName}
                                        </div>
                                        <div className="col-sm-6 col-xs-6 col-md-3 col-lg-3">
                                            <strong>Week Ending:</strong>
                                        </div>
                                        <div className="col-sm-6 col-xs-6 col-md-3 col-lg-3">
                                            {self.state.summary.weekEnding}
                                        </div>
                                        <div className="col-sm-6 col-xs-6 col-md-3 col-lg-3">
                                            <strong>Employee Name:</strong>
                                        </div>
                                        <div className="col-sm-6 col-xs-6 col-md-3 col-lg-3">
                                            {self.state.employeeName}
                                        </div>
                                    </div>
                                    <div className="row ap-padding">
                                        <div className="col-md-12 ap-submit-summary">
                                            <TCSummaryForm summary={self.state.summary} />
                                        </div>
                                    </div>
                                </div>
                                : <LoadingPanel />}
                        </div>
                        <div className="col-sm-12 col-md-7 col-md-offset-2 ap-top-margined">
                            <hr style={{ "border-color": "lightgray" }} />
                            <a href="javascript:window.print();void(0);">Print <i className="fa fa-icon fa-print" /></a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <Modal show={(this.state.showAttestation === FORM_STATE.showAttestation ||
                                this.state.showAttestation === FORM_STATE.showNoAnswer)}>
                                <Modal.Header>
                                    {this.state.attestationHeader}
                                </Modal.Header>
                                <Modal.Body>
                                    <div>
                                        <div ref="progress">
                                            <div className="ap-fullsize ap-padding ap-no-top-padding ap-no-side-padding">
                                                <div className="ap-border-color-green ap-bkg-color-white">
                                                    <div ref="attestProgressDiv" className="ap-bkg-color-allin1-green" style={{ width: `0%`, height: "20px" }}></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div ref="attestDiv">
                                            <span ref="attestLoadingSpan">Loading. Please wait...</span>
                                        </div>
                                    </div>
                                </Modal.Body>
                            </Modal>

                            <Modal size="lg" show={this.state.showAttestation === FORM_STATE.showNoAnswer}>
                                <Modal.Header>
                                    {this.state.attestationHeader}.
                                </Modal.Header>
                                <Modal.Body>
                                    <div dangerouslySetInnerHTML={{ __html: this.state.attestationNoAnswer }}>
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <div className="text-center">
                                        <button onClick={() => {
                                            this.setState({
                                                showAttestation: FORM_STATE.showAttestation
                                            });
                                        }} className="btn btn-info">CLOSE</button>
                                    </div>
                                </Modal.Footer>
                            </Modal>

                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderSubmitting() {
        const self = this;
        const errorMsg = this.state.errorMessage ? <Alert bsStyle="danger">{this.state.errorMessage}</Alert> : <div></div>;
        let btnSubmit = null;

        let editUrl = '';
        if (self.props.role == "people") {
            if (self.state.summary != null && moment(self.state.summary.weekEnding).endOf("week").format("YYYYMMDD") > moment().endOf("week").format("YYYYMMDD")) // future timecard
                editUrl = context.routeUrl(`people/future-tc-entry?edit=1&tid=${self.props.params.timecardId}`);
            else
                editUrl = context.routeUrl(`people/tc-entry?edit=1&tid=${self.props.params.timecardId}`);
        } else {
            let timecardType = "tc-clock-edit";
            if (self.state.timecardType != null && self.state.timecardType.toLowerCase() == "durationtc")
                timecardType = "tc-duration";

            editUrl = context.routeUrl(`${self.props.role}/${timecardType}/${self.props.params.timecardId}`);
        }

        return (
            <div className="ap-form-container ap-submit-body">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 col-md-7 col-md-offset-2">
                            <h2 className="text-center ap-submit-title">Submittal Confirmation</h2>
                        </div>
                        <div className="col-md-7 col-md-offset-2 ap-top-margined">
                            Your timecard and task tracking has been saved.
                            If you have completed your weekly time entry,
                            you may now submit your timecard for payroll processing.
                        </div>
                        <div className="col-md-7 col-md-offset-2">
                            {self.state.summary ?
                                <div>
                                    <div className="ap-top-margined text-center">
                                        <strong>Week Ending {self.state.summary.weekEnding}</strong>
                                    </div>
                                    <div className="col-md-12 ap-submit-summary">
                                        <TCSummaryForm summary={self.state.summary} />
                                    </div>
                                </div>
                                : <LoadingPanel />}
                        </div>
                        <div className="col-sm-12 col-md-7 col-md-offset-2 ">
                            <hr style={{ "border-color": "lightgray" }} />
                            <p>
                                I certify that these hours and dates are correct and have been approved
                                by my assigned approving supervisor. I further certify that I suffered
                                no injuries during this work period.
                            </p>
                            <p dangerouslySetInnerHTML={{ __html: self.state.mealBreakAgreenment }}>
                            </p>
                        </div>
                        <div className="col-sm-12 col-md-7 col-md-offset-2 ap-top-margined">
                            <Checkbox onChange={(evt) => {
                                if (btnSubmit) {
                                    const clone = immutable.fromJS(self.state)
                                        .mergeDeep({ agreementChecked: evt.target.checked })
                                        .toJS();
                                    self.setState(clone);
                                }
                            }}>
                                <span style={{ color: "#4d4d4d", fontSize: "14px", fontWeight: "700" }}>
                                    I have read and agree to the agreement stated above
                                </span>
                            </Checkbox>
                        </div>
                        <div className={self.state.disabled ? "ap-hidden col-sm-12 col-md-7 col-md-offset-2" : "col-sm-12 col-md-7 col-md-offset-2"}>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-md-4">
                                        <button className="btn btn-info ap-fullsize ap-submit-button" ref={node => {
                                            btnSubmit = node;
                                            if (btnSubmit) btnSubmit.disabled = !self.state.agreementChecked;
                                        }} onClick={self.submitTimecard}>Submit Now</button>
                                    </div>
                                    <div className="col-md-4">
                                        <button className="btn btn-info ap-fullsize ap-submit-button"
                                            onClick={() => {
                                                context.redirectToHome();
                                            }}>Submit Later</button>
                                    </div>
                                    <div className="col-md-4">
                                        <button className="btn btn-info ap-fullsize ap-submit-button"
                                            onClick={() => {
                                                browserHistory.push(editUrl);
                                            }}>Edit Timecard</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-7 col-md-offset-2 ap-top-margined">
                            {errorMsg}
                        </div>
                    </div>
                </div>
            </div>);
    }
}